import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const names = ['María González', 'Carlos Rodríguez', 'Ana Martínez', 'Jorge López', 'Silvia Fernández', 'Roberto Pérez', 'Claudia Sánchez', 'Diego Ramírez', 'Patricia Díaz', 'Marcelo Torres', 'Laura Benítez', 'Gustavo Morales', 'Mónica Castro', 'Fernando Ruiz', 'Gabriela Romero'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca', 'San Miguel de Tucumán', 'Resistencia', 'Posadas'];
export function PurchasePopup() {
  const [show, setShow] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    const showPopup = () => {
      setCurrentName(names[Math.floor(Math.random() * names.length)]);
      setCurrentCity(cities[Math.floor(Math.random() * cities.length)]);
      setShow(true);
      setTimeout(() => setShow(false), 4000);
    };
    const initialDelay = setTimeout(showPopup, 3000);
    const interval = setInterval(showPopup, 15000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-104">
      {show && <motion.div initial={{
      opacity: 0,
      x: -100
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} transition={{
      duration: 0.4
    }} className="fixed bottom-6 left-6 z-50 max-w-sm" data-id="element-105">
          <div className="bg-white rounded-lg shadow-2xl overflow-hidden border-2 border-gray-200" data-id="element-106">
            <div className="bg-green-500 px-4 py-2 flex items-center gap-2" data-id="element-107">
              <CheckCircle className="w-5 h-5 text-white" data-id="element-108" />
              <span className="text-white font-bold text-sm" data-id="element-109">
                COMPRA VERIFICADA
              </span>
            </div>
            <div className="p-4" data-id="element-110">
              <p className="text-gray-800 font-medium" data-id="element-111">
                <span className="font-bold" data-id="element-112">{currentName}</span> de{' '}
                <span className="font-bold" data-id="element-113">{currentCity}</span>
              </p>
              <p className="text-gray-600 text-sm mt-1" data-id="element-114">
                Acaba de comprar el KIT Psicología en Gerontes
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}